<div id="template-editor" class="template-editor madero-style"
     [ngClass]="{ 'active-component' : componentsFactory.selected,
                 'desktop-mode': !considerChromeBarHeight }">
  <div>
    <template-editor-toolbar
      class="template-editor-toolbar"
      [ngClass]="{ 'hidden-xs': componentsFactory.selected }">
    </template-editor-toolbar>
  </div>
  <mat-divider class="light" />
  <div class="template-editor-body">
    <div class="attribute-editor">
      <template-attribute-editor>
      </template-attribute-editor>
    </div>
    <div id="preview-holder" class="preview-holder"
         [ngClass]="{ 'hidden-xs': componentsFactory.selected }">
      <presentation-preview>
      </presentation-preview>
    </div>
  </div>

  <template-editor-footer
    class="template-editor-footer navbar-fixed-bottom visible-xs"
    [ngClass]="{ 'hidden-xs': componentsFactory.selected }">
  </template-editor-footer>

</div>
